<template>
  <div class="detail">
    <div class="center">
      <p>支付成功</p>
      <div class="content">
        <img src="../../assets/images/order-confirm/pay-success.png" alt />
        <p>{{ result }}</p>
        <p>我们将尽快为您发货，收货期间请保持手机畅通</p>
        <p class="text" v-if="payWay">
          支付方式:&nbsp;&nbsp;
          <span>{{ payWay }}</span>
        </p>
        <p class="text" v-if="vmId === 5 || vmId === '5'">
          支付积分:&nbsp;&nbsp;
          <span>{{ payPrice | currency('￥', 2) }}</span>
        </p>
        <p class="text" v-else>
          支付金额:&nbsp;&nbsp;
          <span>{{ payPrice | currency('￥', 2) }}</span>
        </p>
        <p>
          <button class="push" @click="$router.push('/mall')">进入首页</button>
          <router-link :to="{ name: 'orderDetail', query: { id: orderId } }">
            <button>查看订单</button>
          </router-link>
        </p>
        <div class="message">
          <i></i>
          <div>温馨提示：<br />*奇瑞不会以订单异常、系统升级为由要求您点击任何网址链接进行退款操作</div>
        </div>
        <el-dialog class="env" title :close-on-click-modal="false" :visible.sync="redEnvShow">
          <div class="imgWrapper">
            <div class="close" @click="redEnvShow = false"></div>
            <div class="to-detail" v-if="prizeLength > 1">恭喜您获得{{ prize }}等权益</div>
            <div class="to-detail" v-else>恭喜您获得{{ prize }}</div>
            <div class="img-env">
              <!-- <p class="to-price">500<span>元</span></p>
              <p class="to-time">有效期至2020-12-30</p>
              <p class="to-text">300积分已添加至您的积分余额</p> -->
            </div>
            <button class="to-button" @click="PrizeTips">确定</button>
          </div>
        </el-dialog>
        <el-dialog class="env1" title :close-on-click-modal="false" :visible.sync="activityShow">
          <div class="img-env1" @click="getUrl">
            <span>恭喜您获得</span>
            <p class="to-text1">抽奖机会</p>
          </div>
          <div class="close1" @click="activityShow = false"></div>
        </el-dialog>
        <!-- 小拼团 -->
        <el-dialog class="showBox" title :close-on-click-modal="false" :visible.sync="isShowBox">
          <div class="boxMain">
            <span class="titleText">
              <span class="lineLeft">-</span>参团成功
              <span class="lineRight">-</span>
            </span>
            <!-- <div class="redBox" v-if="!ifSuccess">
              再邀
              <span>1</span>人即享500元现金红包
            </div> -->
            <div class="redBox groupSuccess" v-if="activityNum > 0">
              邀约{{ activityNum }}人即享
              <span class="joinText" @click="toCouponRed">{{ smallGroupTitle }}</span>
            </div>
            <div class="redBox groupSuccess" v-else>
              恭喜您已组团成功，完成购车后获得
              <span class="joinText" @click="toCouponRed">{{ smallGroupTitle }}</span>
            </div>
            <div class="qrcodeBlock">
              <div id="qrcode" ref="qrcode"></div>
            </div>
            <div class="shareText">微信扫码查看邀约详情</div>
          </div>
          <div class="closeBox" @click="isShowBox = false"></div>
        </el-dialog>
        <!-- 抽奖关联主商品 弹窗 start -->
        <el-dialog class="env1" :visible.sync="isShowDraw">
          <div class="img-env1" :class="musicRain ? 'music-rain' : redRain ? 'red-rain' : ''" @click="goDraw">
            <div v-if="!musicRain && !redRain">
              <span>恭喜您获得</span>
              <p class="to-text1">抽奖机会</p>
            </div>
            <div v-if="redRain" class="red-rain-text">
              <div>恭喜您获得</div>
              <div>抽奖机会</div>
            </div>
            <div v-if="musicRain" class="btn">
              <div style="font-size:20px;margin-right:10px">前往抽奖</div>
              <img style="margin:0" src="../../assets/music-rain2.png" alt="" />
            </div>
          </div>
          <div class="close1" @click="isShowDraw = false"></div>
        </el-dialog>
        <!-- 抽奖关联主商品 弹窗 end -->
      </div>
    </div>
    <red-packet v-model="openRedPacket" :activityId="activityId" :lotteryNumber="availableTime" :ifRefund="ifRefund"></red-packet>
    <!--抽奖-->
  </div>
</template>

<script type="text/javascript">
// import { Loading, Dialog } from 'element-ui'
// import { Dialog } from 'element-ui'
import QRCode from 'qrcodejs2'
import { getStorage } from '@/lib/utils'
// import aConfig from '@/lib/activityConfig'
import redPacket from '@/views/activity/components/red-packet.vue'
import orderApi from '@/api/order.js'
// import depositRedpacket from './activity/deposit-redpacket.vue'
import groupApi from '@/api/activity'
export default {
  name: 'pay-success',
  data() {
    return {
      activityNum: 0,
      prize: '',
      prizeLength: 0,
      vmId: '',
      payWay: '微信支付',
      payPrice: 0,
      orderId: '',
      result: '支付中',
      count: 0,
      // 最大请求次数
      loadMax: 3,
      task: null,
      redEnvShow: false,
      activityShow: false,
      isShowBox: false,
      isShowCrowBox: false,
      crowdfundingInfo: null,
      envDetail: {},
      acId: '',
      groupOrderId: '',
      shareId: '',
      shareInfoType: '',
      ifSuccess: false,
      channel: ['', '微信支付', '快捷支付', '网银支付'],
      activityId: null,
      openRedPacket: false, // 抽奖弹框
      ifRefund: false, // 抽奖是否推过款 true退过
      availableTime: null, // 剩余抽奖次数
      linkActUrl: '',
      smallGroupTitle: '',
      allEquitys: [], // 订金升档权益
      isShowDraw: false, // 抽奖关联主商品
      drawActivityId: '', // 抽奖活动Id
      requestTimes: 1, // 轮询请求次数
      getOrderStatusTimer: null, // 轮询定时器
      musicRain: false, // 是否音乐雨
      redRain: false // 是否红包雨
    }
  },
  computed: {
    // getEquitys() {
    //   return this.$store.state.equitys
    // }
  },
  components: {
    // ElDialog: Dialog,
    // QRCode,
    redPacket
    // depositRedpacket
  },
  /* eslint-disable */
  methods: {
    bindQRCode() {
      const dealercardwebUrl = getStorage('domain', 'localStorage').h5mallUrl
      const url = dealercardwebUrl + '/pages/activity/smallGroupDetail?orderId=' + this.orderId
      return new QRCode(this.$refs.qrcode, {
        text: url,
        width: 214,
        height: 214,
        colorDark: '#000000', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L // 容错率，L/M/H
      })
    },
    PrizeTips() {
      this.redEnvShow = false
      this.$feedback('领取成功')
    },
    toCouponRed() {
      this.$router.push({ path: '/personCenter/coupon' })
    },
    async getShareDetail() {
      const res = await groupApi.shareDetail({ orderId: this.orderId })
      this.activityNum = res.data.shareFissionDto.quantity - res.data.shareGroupJoinRecordDto.length
    },
    /**
     * @descripttion: 查询活动订单支付状态
     * @Author: cuiyuan
     * @Date: 2021-09-15 10:15:28
     * @param {number} type [活动类型 3抽奖（红包也是抽奖）]
     * @return {void}
     */
    checkActivityOrder(type) {
      let that = this
      let orderId = this.orderId
      let activityId = this.drawActivityId
      let data = {
        orderId: orderId,
        activityId: activityId,
        activityType: type
      }
      this.getOrderStatusTimer = setTimeout(() => {
        groupApi.checkActivityOrder(data).then((res) => {
          if (res.status === 200) {
            if (res.data != null || that.requestTimes === 10) {
              if (res.data.lotteryOrderResultVO && res.data.lotteryOrderResultVO.getLottery) {
                that.isShowDraw = true // 抽奖弹窗
              }
              clearTimeout(that.checkActivityOrderTimer)
            } else {
              that.checkActivityOrder(type)
              that.requestTimes = ++that.requestTimes
            }
          }
        })
      }, 500)
    },
    async getPayResult() {
      try {
        const res = await orderApi.getOrderDetail({ orderId: this.orderId })
        if (res.status === 200) {
          let orderGoods = res.data.orderContracts[0].orderItemDtoList[0]

          // 小拼团
          if (orderGoods.itemType === 0 || orderGoods.itemType === '0') {
            if (orderGoods.extraMap && orderGoods.extraMap.smallGroup) {
              this.smallGroupTitle = orderGoods.extraMap.smallGroup.title
              await this.getShareDetail()
              this.isShowBox = true
              this.$nextTick(function() {
                this.bindQRCode(res.data.order.id)
              })
            }
          }
          // 其他活动
          let activity = orderGoods.extraMap.activity || ''

          if (activity) {
            this.drawActivityId = activity.activityId
            this.musicRain = activity.activityPageType === 4
            this.redRain = activity.activityPageType === 6
            // 抽奖、下单助力、竞猜活动，订单未支付完成
            if (activity.activityType === 3) {
              this.checkActivityOrder(activity.activityType)
            } else if (activity.linkActivityType) {
              // 后置活动
              this.drawActivityId = activity.linkActivityId
              switch (activity.linkActivityType) {
                case 3: // 抽奖
                  this.isShowDraw = true
                  this.musicRain = activity.linkActivityPageType === 4
                  this.redRain = activity.linkActivityPageType === 6
                  this.linkActUrl = activity.pcLinkActUrl
                  break
                default:
                  if (activity.pcLinkActUrl) {
                    this.activityShow = true
                    this.linkActUrl = activity.pcLinkActUrl
                  }
                  break
              }
            }
          }
          this.vmId = res.data.order.vmId
          this.payPrice = res.data.order.fee
        } else {
          if (this.count >= this.loadMax) {
            this.$feedback(res.message)
          }
        }
      } catch (error) {
        if (this.count >= this.loadMax) {
          this.$feedback(error.message)
        }
      }
    },
    getUrl() {
      let token = getStorage('access_token')
      window.open(this.linkActUrl + '&vmId=' + 1 + '&orderId=' + this.orderId + '&token=' + token, '_blank')
    },
    goDraw() {
      let token = getStorage('access_token')
      let config = getStorage('domain')
      window.open(config.DOMAIN.activity2c + '/lottery?activityId=' + this.drawActivityId + '&token=' + token, '_blank')
    },
    // // 生成二维码
    transUrl(target) {
      const urlTrans = {
        'http://mall.chery.dtsam.cn': 'https://h5mall-test.chery.cn',
        'http://mall-sit.chery.cn': 'https://h5mall-sit.chery.cn',
        'http://mall.chery.cn': 'https://h5mall.chery.cn',
        'https://mall.chery.dtsam.cn': 'https://h5.chery.dtsam.cn',
        'https://mall-sit.chery.cn': 'https://h5mall-sit.chery.cn',
        'https://mall.chery.cn': 'https://h5mall.chery.cn'
      }
      return urlTrans[target] ? urlTrans[target] : 'https://h5mall-test.chery.cn'
    },
    // 获取用户id
    getUserId() {
      orderApi.getUserInfo().then((res) => {
        if (res.status === 200) {
          this.userId = res.data.id // 用户id
        }
      })
    }
  },
  created() {
    this.orderId = this.$route.params.orderId
    this.getPayResult()
    // 获取用户id
    this.getUserId()
    // 获取订单id
    this.result = '订单支付成功'
  }
}
</script>

<style scoped lang="scss">
#qrcodex {
  > img {
    margin-top: 0;
  }
}
.detail {
  background: #f9f9f9;
  padding-bottom: 40px;
  .env ::v-deep {
    .el-dialog__header {
      display: none;
    }
    .el-dialog {
      background: transparent !important;
      box-shadow: none;
    }
    .imgWrapper {
      width: 591px;
      height: 684px;
      margin: 0 auto;
      position: relative;
      background: linear-gradient(135deg, #fff2e8 0%, #ffe2dc 100%);
      .close {
        width: 38px;
        height: 38px;
        background-image: url('../../assets/cha.png');
        -webkit-background-size: 100% 100%;
        position: absolute;
        top: 17px;
        right: 25px;
      }
      .to-detail {
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #765738;
        margin: 0 auto;
        padding-top: 76px;
      }
      .img-env {
        width: 540px;
        height: 413px;
        position: absolute;
        top: 160px;
        left: 60px;
        background-image: url('../../assets/prize.png');
        -webkit-background-size: 100% 100%;
        // .to-price {
        //   font-size: 80px;
        //   font-family: PingFangSC-Medium, PingFang SC;
        //   font-weight: 500;
        //   color: #9e5548;
        //   span {
        //     font-size: 40px;
        //     color: #9e5548;
        //   }
        // }
        // .to-time {
        //   font-size: 22px;
        //   font-family: PingFangSC-Regular, PingFang SC;
        //   font-weight: 400;
        //   color: #9e5548;
        // }
        // .to-text {
        //   margin: 0;
        //   margin-top: 165px;
        //   font-size: 22px;
        //   font-family: PingFangSC-Regular, PingFang SC;
        //   font-weight: 400;
        //   color: #ffffff;
        // }
      }
      .to-button {
        // margin-top: 70px;
        outline: none;
        margin-top: 440px;
        width: 544px;
        height: 81px;
        background: linear-gradient(145deg, #ef5d42 0%, #da1f46 100%);
        border-radius: 13px;
        border: none;
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
  .env1 ::v-deep {
    .el-dialog__header {
      display: none;
    }
    .el-dialog {
      background: transparent !important;
      box-shadow: none;
    }
    .img-env1 {
      width: 400px;
      height: 500px;
      position: relative;
      background-image: url('../../assets/activityPicture2.png');
      -webkit-background-size: 100% 100%;
      margin: 0 auto;
      font-size: 42px;
      color: #833816;
      line-height: 290px;
      font-weight: bold;
      span {
        position: absolute;
        top: 180px;
        left: 145px;
        font-size: 22px;
        color: #fff;
        font-weight: 400;
      }
      .to-text1 {
        position: absolute;
        bottom: 100px;
        font-size: 30px;
        color: #ffe288;
        width: 100%;
      }
    }
    .music-rain {
      position: relative;
      background-image: url('../../assets/music-rain.png');
      .btn {
        height: 60px;
        width: 215px;
        left: 94px;
        position: absolute;
        background-image: url('../../assets/music-rain1.png');
        background-size: 100% 100%;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 1;
        img {
          height: 22px;
          width: 22px;
          position: relative;
          top: 2px;
        }
      }
    }
    .red-rain {
      position: relative;
      background-image: url('../../assets/redrain-bg.png');
      background-position-x: 8px;
      .red-rain-text {
        line-height: 1;
        text-align: center;
        padding-top: 155px;
        letter-spacing: 2px;
        line-height: 35px;
        font-weight: bold;
        font-size: 22px;
        color: #ce3419;
      }
    }
    .close1 {
      height: 42px;
      width: 42px;
      margin: 24px auto 20px;
      background-image: url('../../assets/icons/my/icon_close.png');
      background-size: cover;
      cursor: pointer;
    }
  }
}
.center {
  width: 1360px;
  margin: 0 auto;
  color: #333;
  > p {
    font-size: 16px;
    line-height: 62px;
    text-align: left;
  }
  .content {
    background: #fff;
    text-align: center;
    width: 1360px;
    height: 600px;
    img {
      width: 90px;
      height: 90px;
      margin-top: 79px;
    }
    p {
      font-size: 16px;
      line-height: 42px;
      span {
        color: #c6001f;
      }
      &.text {
        color: rgba(51, 51, 51, 1);
        padding-left: 608px;
        text-align: left;
      }
    }
    p:nth-of-type(1) {
      font-size: 20px;
      line-height: 28px;
      font-weight: 500;
      margin-top: 30px;
    }
    p:nth-of-type(2) {
      color: #777777;
      font-size: 18px;
      line-height: 25px;
      margin-top: 20px;
    }
    p:last-of-type {
      margin-top: 32px;
      button {
        width: 133px;
        height: 40px;
        line-height: 40px;
        border: 1px solid rgba(51, 51, 51, 1);
        background: #fff;
        cursor: pointer;
      }
      .push {
        background: #000;
        color: #fff;
        margin-right: 25px;
      }
    }
    .message {
      position: relative;
      width: 700px;
      height: 98px;
      background: rgba(247, 165, 0, 0.1);
      border: 1px solid rgba(247, 165, 0, 0.35);
      text-align: left;
      margin: 40px auto;
      i {
        position: absolute;
        top: 22px;
        left: 40px;
        width: 16px;
        height: 16px;
        background: url('../../assets/images/order/warning.png') center center no-repeat;
      }
      div {
        margin-left: 64px;
        margin-top: 22px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }
    }
    .showBox {
      &::v-deep {
        .el-dialog__body {
          padding: 74px 25px 0 25px;
        }
        .el-dialog__header {
          display: none;
        }
        .el-dialog {
          // background: transparent !important;
          width: 364px;
          height: 487px;
          box-shadow: none;
          background: url('../../assets/images/activity/group-success.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      .boxMain {
        text-align: center;
        .titleText {
          color: #fff;
          display: block;
          font-size: 28px;
          font-weight: bold;
          height: 37px;
          line-height: 37px;
          .lineLeft {
            color: #fff;
            margin-right: 7px;
          }
          .lineRight {
            color: #fff;
            margin-left: 7px;
          }
        }
        .shareText {
          color: #fff;
          opacity: 0.8;
          margin: 10px 0 20px 0;
          font-size: 20px;
        }
        .redBox {
          font-size: 22px;
          font-family: MicrosoftYaHei;
          color: #fff;
          margin: 15px 0;
          span {
            color: #ffe489;
          }
          .joinText {
            cursor: pointer;
            color: #ffe489;
            text-decoration: underline;
          }
        }
        .groupSuccess {
          margin: 10px;
        }
        // .right {
        //   display: block;
        //   margin: 10px auto;
        //   width: 40px;
        //   height: 40px;
        //   background-image: url('../../assets/images/order/groupRight.png');
        //   background-size: 100% 100%;
        // }
        .qrcodeBlock {
          margin: 0 auto;
          width: 214px;
          height: 214px;
          // padding: 3px;
          background: #fff;
        }
      }
      .closeBox {
        height: 42px;
        width: 42px;
        margin: 106px auto 20px;
        background-image: url('../../assets/icons/my/icon_close.png');
        background-size: cover;
        cursor: pointer;
      }
    }
    .crowBox {
      font-size: 24px;
      color: #666;
      p {
        margin: 0;
      }
      ::v-deep {
        .el-dialog__body {
          padding: 40px 101px 0;
        }
        .el-dialog__header {
          display: none;
        }
        .el-dialog {
          // background: transparent !important;
          width: 520px;
          height: 600px;
          box-shadow: none;
          background: #fff;
          border-radius: 15px;
        }
      }
      h1 {
        width: 152px;
        height: 50px;
        font-size: 38px;
        font-weight: bold;
        color: rgba(37, 37, 37, 1);
        line-height: 50px;
        margin: 0 auto 20px;
      }
      .qrcodeBlock {
        margin: 24px auto;
      }
      .closeBox {
        height: 42px;
        width: 42px;
        margin: 100px auto 20px;
        background-image: url('../../assets/icons/my/icon_close.png');
        background-size: cover;
        cursor: pointer;
      }
    }
    .crowBoxEnd {
      ::v-deep {
        .el-dialog {
          height: 455px;
        }
        .check {
          display: inline-block;
          color: #c6001f;
          text-decoration: underline;
          margin-top: 35px;
        }
      }
      h1 {
        width: 152px;
        height: 50px;
        font-size: 38px;
        font-weight: bold;
        color: rgba(37, 37, 37, 1);
        line-height: 50px;
        margin: 0 auto 20px;
      }
      .qrcodeBlock {
        display: none;
      }
      .success {
        width: 91px;
        height: 91px;
        margin: 15px auto 35px;
      }
    }
  }
}
</style>
